//@ts-ignore
import { PROBLEM_INNER_TYPES } from '@yandex-int/k-common/constants';
import { StudentProblemResult, LessonProblem } from '@yandex-int/k-common/typings';
import { isCodingProblem } from 'platform-components/src/components/coding-problem/utils';
import { isRobotProblem } from 'platform-components/src/components/robot/utils/isRobotProblem';
import { isWebProblem } from 'platform-components/src/components/web-problem/utils';
import { isWebserviceProblem } from 'platform-components/src/components/webservice-problem/utils';
import React from 'react';

import { AttemptsCounter } from '../_student-attempts-value/attempts-counter';
import { EmptyAttempts } from '../_student-attempts-value/empty-attempts';
import { InfinityAttempts } from '../_student-attempts-value/infinity-attempts';

export const CommonAttemptsText = (props: {
    studentProblemResult: StudentProblemResult | null;
    problemLink: LessonProblem;
}) => {
    const { studentProblemResult, problemLink } = props;

    if (!studentProblemResult) {
        return <EmptyAttempts />;
    }

    const isEditableProblem = problemLink?.problem?.type === PROBLEM_INNER_TYPES.EDITABLE;
    const isInfiniteAttempts =
        isCodingProblem(problemLink.problem) ||
        isRobotProblem(problemLink.problem) ||
        isWebProblem(problemLink.problem) ||
        isWebserviceProblem(problemLink.problem) ||
        isEditableProblem;
    if (isInfiniteAttempts) {
        return <InfinityAttempts studentProblemResult={studentProblemResult} />;
    }

    return <AttemptsCounter studentProblemResult={studentProblemResult} />;
};
